import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const ListIcon = ({ label = 'List', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#b1ce5f" d="M48.7 36.8h202.6v226.39H48.7z"/><path d="M251.3 36.8v226.4H48.7V36.8h202.6m0-10H48.7a10 10 0 0 0-10 10v226.4a10 10 0 0 0 10 10h202.6a10 10 0 0 0 10-10V36.8a10 10 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M84.1 97.7V82.6a15.2 15.2 0 0 1 15.2-15.1h15.1a15.2 15.2 0 0 1 15.1 15.1v15.1a15.2 15.2 0 0 1-15.1 15.1H99.3a15.2 15.2 0 0 1-15.2-15.1zm0 120.9v-15.1a15.2 15.2 0 0 1 15.2-15.2h15.1a15.2 15.2 0 0 1 15.1 15.2v15.1a15.2 15.2 0 0 1-15.1 15.1H99.3a15.2 15.2 0 0 1-15.2-15.1zm.8-71.3a2.7 2.7 0 0 1 0-3.6l6-6a2.7 2.7 0 0 1 3.6 0l9.8 9.9 22.4-22.3a2.5 2.5 0 0 1 3.6 0l6 6a2.5 2.5 0 0 1 0 3.6l-30.3 30a2.5 2.5 0 0 1-3.6 0zm14.4-49.6h15.1V82.6H99.3zm0 120.9h15.1v-15.1H99.3zm45.3-124.7v-7.5a3.8 3.8 0 0 1 3.7-3.8h60.5a3.8 3.8 0 0 1 3.7 3.8v7.5a3.8 3.8 0 0 1-3.7 3.8h-60.5a3.8 3.8 0 0 1-3.7-3.8zm0 60.5v-7.6a3.8 3.8 0 0 1 3.7-3.8h60.5a3.8 3.8 0 0 1 3.7 3.8v7.6a3.8 3.8 0 0 1-3.7 3.7h-60.5a3.8 3.8 0 0 1-3.7-3.7zm0 60.4v-7.6a3.8 3.8 0 0 1 3.7-3.7h60.5a3.8 3.8 0 0 1 3.7 3.7v7.6a3.8 3.8 0 0 1-3.7 3.8h-60.5a3.8 3.8 0 0 1-3.7-3.8z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

ListIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { ListIcon }
